import clsx from 'clsx'

import styles from './icon.module.css'
import type { IconDefaultProps } from './types'

const Clock = ({ className }: IconDefaultProps): JSX.Element => (
  <svg
    className={clsx(styles.icon, className)}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path d='M9.375 4.375C9.375 4.0625 9.64844 3.75 10 3.75C10.3125 3.75 10.625 4.0625 10.625 4.375V9.6875L14.0625 11.9922C14.375 12.1875 14.4531 12.5781 14.2578 12.8516C14.0625 13.1641 13.6719 13.2422 13.3984 13.0469L9.64844 10.5469C9.45312 10.4297 9.33594 10.2344 9.33594 10L9.375 4.375ZM10 0C15.5078 0 20 4.49219 20 10C20 15.5469 15.5078 20 10 20C4.45312 20 0 15.5469 0 10C0 4.49219 4.45312 0 10 0ZM1.25 10C1.25 14.8438 5.15625 18.75 10 18.75C14.8047 18.75 18.75 14.8438 18.75 10C18.75 5.19531 14.8047 1.25 10 1.25C5.15625 1.25 1.25 5.19531 1.25 10Z' />
  </svg>
)

export default Clock
